export default __webpack_public_path__ + "static/media/README.92e05fef.md";